import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { Bill } from "@common/types/bill";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Button } from "@design-system/Button/Button";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { ArrowCornerIcon } from "@icons";
import { getBillUrl, getBillUrlTitle } from "@helpers/bills";

export const ExternalLinkCell = memo(
    ({ row }: CellContext<ViewTableFeatures, Bill, any>) => {
        const bill = row.original;
        const url = getBillUrl(bill);

        if (!url) {
            return <ViewTableCell />;
        }

        const billUrlTitle = getBillUrlTitle(bill);

        return (
            <ViewTableCell captureClicks>
                <Tooltip content={billUrlTitle}>
                    <Button
                        size="sm"
                        iconOnly
                        variant="secondary"
                        aria-label={billUrlTitle || "Open bill"}
                        onClick={(e) => {
                            e.stopPropagation();
                            window.open(url, "_blank");
                        }}
                    >
                        <ArrowCornerIcon />
                    </Button>
                </Tooltip>
            </ViewTableCell>
        );
    },
);
